import React, { useMemo, useCallback } from "react";
import { Grid, Select } from "semantic-ui-react";
import { SelectFieldProps } from "../../types";

const SelectField: React.FC<SelectFieldProps> = ({
  title,
  inputKey,
  value,
  isRequired = false,
  handleChange,
  options,
  errorMessage,
}) => {
  const dropdownOptions = useMemo(() => {
    return (
      options?.map((option: string) => ({
        key: option,
        text: option,
        value: option,
      })) || []
    );
  }, [options]);

  const handleDropdownChange = useCallback(
    (e: React.SyntheticEvent<HTMLElement>, data: any) => {
      handleChange({ name: inputKey, value: data.value });
    },
    [handleChange, inputKey],
  );

  return (
    <Grid.Row>
      <Grid.Column className="flex vcenter" textAlign="left" width={8}>
        <h5>
          {title}
          {isRequired && (
            <span className="color-red padding-left-half bold">*</span>
          )}
        </h5>
      </Grid.Column>
      <Grid.Column className="flex vcenter" textAlign="left" width={8}>
        <Select
          icon="chevron circle down"
          className="select-box full"
          placeholder={`Select ${title}`}
          options={dropdownOptions}
          value={value || ""}
          onChange={handleDropdownChange}
          error={!!errorMessage}
        />
        {errorMessage && <span className="error-message">{errorMessage}</span>}
      </Grid.Column>
    </Grid.Row>
  );
};

export default SelectField;
